
import { Vue, Component } from 'vue-property-decorator';
import { Toast, Popup } from 'vant';

const appKey = 'FFFF000000000168EBF9';

@Component
export default class SlideVerify extends Vue {
  NC: any = null; // 滑动验证实例
  mounted() {
    this.init();
  }

  init() {
    const ncToken = [appKey, new Date().getTime(), Math.random()].join(':');
    // 设置滑动验证配置
    const NCOpt = {
      renderTo: '#nc', // 渲染到该DOM ID指定的Div位置
      appkey: appKey, // 应用标识,不可更改
      scene: 'activity_h5', // 场景,不可更改
      token: ncToken,
      bannerHidden: false,
      callback: (data: any) => {
        // 校验成功回调
        const SlideData = {
          token: ncToken,
          csessionid: data.csessionid,
          sig: data.sig,
          scene: 'activity_h5',
        };

        this.$emit('getSlideData', SlideData);
      },
      error: (error: any) => {
        Toast.fail(error);
        console.log('slide fail:', error);
      },
    };
    this.NC = window.NoCaptcha.init(NCOpt);
    (window.NoCaptcha as any).setEnabled(true);
    this.NC.reset();
  }
  reset() {
    this.NC.reset();
  }
}
